export interface checkExternalIdExistsPayload {
    externalId: string
}
export interface checkExternalIdExistsOrNot {
    data: {
        isSameOrgEntity: boolean,
        isExternalIdAlreadyPresent: boolean,
        newOrgEntityId: string,
        isNew: boolean
    },
    isActionSuccess: boolean
}

export interface createNewPatient {
    data: {
        isIndividual: boolean,
        type: string,
        displayName: string,
        firstName: string,
        lastName: string,
        dateOfBirth: string,
        birthGender: string,
        externalId: string,
        phoneNumbers: phoneDetails[],
        emailAddresses: emailDetails[],
        orgEntityId: string
    }
    isAlreadyPresent: boolean
}
export interface phoneDetails {
    phoneId: string,
    phoneNumber: string,
    isPrimary: boolean,
    type: string,
    isReserved: boolean,
    isVoiceNumber: boolean,
    isSmsNumber: boolean
}
export interface emailDetails {
    emailId: string,
    email: string,
    type: string,
    isPrimary: boolean,
    isReserved: boolean
}

export const months = [
    {
        id: '01',
        displayName: 'January',
        maxDays: 31,
    },
    {
        id: '02',
        displayName: 'February',
        maxDays: 29,
    },
    {
        id: '03',
        displayName: 'March',
        maxDays: 31,
    },
    {
        id: '04',
        displayName: 'April',
        maxDays: 30,
    },
    {
        id: '05',
        displayName: 'May',
        maxDays: 31,
    },
    {
        id: '06',
        displayName: 'June',
        maxDays: 30,
    },
    {
        id: '07',
        displayName: 'July',
        maxDays: 31,
    },
    {
        id: '08',
        displayName: 'August',
        maxDays: 31,
    },
    {
        id: '09',
        displayName: 'September',
        maxDays: 30,
    },
    {
        id: '10',
        displayName: 'October',
        maxDays: 31,
    },
    {
        id: '11',
        displayName: 'November',
        maxDays: 30,
    },
    {
        id: '12',
        displayName: 'December',
        maxDays: 31,
    },
]